import React from 'react';
import SectionHeader from './SectionHeader';
import Field from './Field';
import styles from '../SaleReportPage.module.scss';

const TextIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 6h16" />
    <path d="M4 12h16" />
    <path d="M4 18h10" />
  </svg>
);

function DescriptionSection({ config, sale, onChange }) {
  const bodyLen = (config.body || '').length;

  return (
    <>
      <SectionHeader
        icon={<TextIcon />}
        title="제목 · 본문"
        locked="필수 영역"
      />
      <div className={styles.grid}>
        <Field label="제목" span={12} required>
          <input
            type="text"
            value={config.title || ''}
            onChange={(e) => onChange({ ...config, title: e.target.value })}
            placeholder={sale?.title || '언주역 초역세권, 봉은사로 이면 사옥형 상업용 건물'}
          />
        </Field>

        <Field label="본문" span={12} hint="800~1,000자 권장">
          <textarea
            className={styles.textarea}
            value={config.body || ''}
            onChange={(e) => onChange({ ...config, body: e.target.value })}
            placeholder="매물의 입지·건물 사양·임대 환경·투자 매력을 단락별로 작성해 주세요."
          />
          <span className={styles.hintText}>{bodyLen.toLocaleString()}자</span>
        </Field>
      </div>
    </>
  );
}

export default DescriptionSection;
